module.exports = __webpack_public_path__ + "img/EQULIZER.57267d94.svg";